<template>
  <v-container fluid>
    <v-row>
      <!-- filter -->
      <v-col cols="12" md="3">
        <wapi-panel :title="'Фильтр'">
          <template v-slot:content>
            <v-select
              v-model="userId"
              :items="users"
              item-text="name"
              item-value="id"
              label="Клиент"
              @input="onChangeUser"
              dense
              outlined
            ></v-select>
            <wapi-presets
              :items="presets"
              v-model="presetId"
              :disabled="false"
              :multiple="multiple"
              @input="onChangePreset"
              :userId="userId"
            />
          </template>
        </wapi-panel>
      </v-col>
      <!-- presets -->
      <v-col cols="12" md="9">
        <wapi-panel v-if="userId">
          <template v-slot:toolbar></template>
          <template v-slot:content>
            <managed-presets :userId="userId" :pvariants="pvariants" :predicts="predicts" />
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WapiContract from "../models/contract/WapiContract";
import { areaInKm2, areaInHa } from "../helpers/common";
import ManagedPresets from "../components/ManagedPresets.vue";
import WapiPanel from "../components/WapiPanel";
import WapiPresets from "../components/WapiPresets.vue";

export default {
  name: "ManagedPresetsView",
  title: "Территории",
  components: {
    ManagedPresets,
    WapiPanel,
    WapiPresets
  },
  async mounted() {
    await this.$store.dispatch("FETCH_USERS");
    this.users = this.$store.getters.USERS;
  },
  data: function() {
    return {
      page: 1,
      paginationTotalVisible: 10,
      perPage: 6,
      pvariants: [],
      dvariant: null,
      presets: [],
      contract: new WapiContract(),
      dvariants: [],
      predicts: [],
      users: [],
      userId: "",
      presetId: "",
      multiple: false
    };
  },
  computed: {
    paginationLength() {
      return Math.ceil(this.presets.length / this.perPage);
    },
    pagePresets() {
      const from = (this.page - 1) * this.perPage;
      const to = this.page * this.perPage;
      return this.presets.slice(from, to);
    },
    pagination() {
      return !!this.pagePresets.length;
    },
    userName() {
      if (!this.userId) return "";
      return this.users.find(x => x.id === this.userId).name;
    },
    totalAreaInKm() {
      const reducer = (accumulator, currentValue) =>
        accumulator + Math.round(areaInKm2(currentValue.area.geometry));
      return this.pagePresets.reduce(reducer, 0);
    },
    totalAreaInHa() {
      const reducer = (accumulator, currentValue) =>
        accumulator + Math.round(areaInHa(currentValue.area.geometry));
      return this.pagePresets.reduce(reducer, 0);
    },
    anyPreset: function() {
      return this.presets.length > 0;
    }
  },
  methods: {
    openPreset() {
      this.$router.push({
        name: "PRESET_DETAILS",
        params: { userId: this.userId, presetId: this.presetId }
      });
    },
    async onChangeUser() {
      await this.$store.dispatch("SET_LOADING", true);
      this.reset();
      await this.$store.dispatch("SET_LOADING", false);
    },
    async onChangePreset() {
      const preset = this.presets.find(p => p.id === this.presetId);
      this.openPreset(preset);
      this.presetId = null;
    },
    reset() {
      this.page = 1;
    }
  }
};
</script>